module.exports = {
      id: "play-solid-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#play-solid",
      toString: function () {
        return this.url;
      }
    }